core.constant('calendarMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "ENUM": {
        "MOON_PHASE": {
          "NEW" : "Nów",
          "WAXING_CRESCENT" : "Przybywający sierp",
          "FIRST_QUARTER" : "Pierwsza kwadra",
          "WAXING_GIBBOUS" : "Przybywający garb",
          "FULL" : "Pełnia",
          "WANING_GIBBOUS" : "Ubywający garb",
          "THIRD_QUARTER" : "Trzecia kwadra",
          "WANING_CRESCENT" : "Ubywający sierp"
        },
        "CALENDAR_VIEW_MODE": {
          "DAY" : "Dzień",
          "PLAN" : "Plan dnia"
        },
        "PAYER_TYPE": {
          "INSURER" : "Podmiot zlecający",
          "PATIENT" : "Pacjent"
        },
        "TERM_TYPE": {
          "EXTERNAL": "Stacjonarna",
          "PRIVATE_TERM": "Termin prywatny",
          "CLAIM": "Orzeczenie ICR",
          "EXAMINATION": "Badanie",
          "ONLINE_CONSULTATION": "Wideokonsultacja",
          "TRIP": "Wyjazdowa",
          "INTERNAL": "Wizyta wewnętrzna"
        },
        "APPOINTMENT_STATUS": {
          "PRERESERVATION": "Zaplanowana",
          "RESERVATION": "Zaplanowana",
          "CANCELLATION": "Odwołana",
          "CANCELLATION_BY_MEDICAL_POST_TO_REORGANIZE": "Odwołana przez placówkę (do reorganizacji)",
          "CANCELLATION_BY_MEDICAL_POST_DONE": "Odwołana przez placówkę (zreorganizowana)",
          "CANCELLATION_BY_CUSTOMER": "Odwołana przez pacjenta",
          "DONE": "Zrealizowana"
        },
        "RECURRENCE_PATTERN": {
          "MONTH": "Co miesiąc",
          "WEEK": "Co tydzień",
          "DAY": "Codziennie",
          "YEAR": "Co rok"
        },
        "CYCLIC_TERM_UPDATE_TYPE": {
          "THIS": "Ten",
          "THIS_AND_UPCOMING": "Ten i kolejne",
          "ALL": "Wszystkie"
        },
        "VISIT_STATUS": {
          "PLANNED" : "Zaplanowana",
          "IN_PROGRESS": "W trakcie",
          "COMPLETED": "Zakończona",
          "CANCELED" : "Anulowana",
          "SUSPENDED": "Do uzupełnienia"
        }
      },
      "UI": {
        "TAB": {
        },
        "BUTTON": {
        },
        "BREADCRUMB": {
        }
      },
      "MODULE": {
        "TITLE": {
          "CALENDAR": "Calendar module"
        },
        "CALENDAR": {
          "VIDEO_CONSULTATION" : "Konsultacja wideo",
          "CALENDAR_DAILY": "Kalendarz (Dzień)",
          "CALENDAR_PLAN": "Kalendarz (Plan dnia)",
          "VIEW": "Widok",
          "NAMEDAYS": "Imieniny",
          "MOON_PHASE": "Faza księżyca",
          "SHOW_EARLIER": "Pokaż wcześniejsze",
          "SHOW_SHORTENED": "Pokaż od 6:00",
          "SHOW_MORE": "Pokaż więcej",
          "UPCOMING_TERMS": "Wolne terminy w najbliższych dniach",
          "ALL_RESOURCES": "Wszystko",
          "TERM": {
            "NEW_TERM": "Nowy termin",
            "PRIVATE_TERM": "Termin prywatny",
            "EDIT_PRIVATE_TERM": "Edycja terminu prywatnego",
            "EVENT_NAME": "Nazwa",
            "PLACE": "Miejsce",
            "DATE_AND_TIME": "Data i czas",
            "RECURRENCE": "Powtarzanie",
            "NOTES": "Notatki",
            "ALL_DAY": "Termin całodzienny",
            "GRANULAR": "Co 5 min.",
            "CYCLIC_MODE": "Tryb",
            "TERM_DELETED": "Termin usunięto!",
            "RESTORE_TERM": "Przywróć"
          },
          "PATIENT": {
            "PATIENT": "Pacjent",
            "NEW_PATIENT": "Nowy pacjent",
            "FIRST_NAME": "Imię",
            "LAST_NAME": "Nazwisko",
            "IDENTIFIER_TYPE": "Typ identyfikatora",
            "IDENTIFIER": "Identyfikator",
            "PHONE": "Telefon",
            "EMAIL": "E-mail",
            "ADDRESS": "Adres pacjenta",
            "PATIENT_SEARCH": "Szukaj pacjenta",
            "ADD_NEW_PATIENT": "Dodaj nowego pacjenta",
            "ERROR": {
              "PATIENT_NOT_FOUND": "Nie znaleziono pacjenta."
            },
            "VALIDATION": {
              "PATIENT": "Wybierz pacjenta"
            }
          },
          "APPOINTMENT": {
            "APPOINTMENT": "Wizyta",
            "EDIT_APPOINTMENT": "Edycja wizyty",
            "APPOINTMENT_LENGTH": "Czas trwania wizyty",
            "APPOINTMENT_DETAILS": "Szczegóły wizyty",
            "APPOINTMENT_DATE": "Termin wizyty",
            "APPOINTMENT_TYPE": "Typ wizyty",
            "RESOURCE": "Gabinet",
            "STATUS": "Status wizyty",
            "VISIT_TYPE": "Rodzaj wizyty",
            "ADDITIONAL_REMARKS": "Dodatkowe uwagi",
            "P1_DOCUMENTATION": "Dokumentacja P1",
            "ONLINE_CONSULTATION_DETAILS": "Szczegóły wideokonsultacji",
            "CANCEL_APPOINTMENT": "Odwołaj wizytę",
            "START_APPOINTMENT": "Rozpocznij",
            "MEDICAL_DOCUMENTATION": "Dokumentacja medyczna",
            "INSURER": "Zleceniodawca",
            "PAYER": "Płatnik",
            "CODE": "Kod weryfikacyjny",
            "SERVICE_RANGE": "Zakres zlecenia",
            "SUM": "Suma",
            "CANCELLATION": "Odwołanie wizyty",
            "CANCEL_REASON": "Przyczyna odwołania wizyty",
            "CANCEL_ADDITIONAL_REMARKS": "Dodatkowe uwagi dotyczące odwołania wizyty",
            "SHOW_VISIT_CARD" : "Pokaż kartę medyczną",
            "VIEW_PATIENT": "Pokaż pacjenta",
            "SAVE_TERM_CONFIRMATION_MESSAGE" : "Termin koliduje z już istniejącymi terminami.",
            "APPOINTMENT_DATE_OPTION": {
              "NEAREST": "Najbliższe",
              "IN_A_WEEK": "Za tydzień",
              "IN_A_MONTH": "Za miesiąc",
              "IN_3_MONTHS": "Za 3 miesiące",
              "BEYOND_AVAILABILITY": "Poza dostępnością"
            },
            "VALIDATION": {
              "CODE": "Kod weryfikacyjny - 4 znakowy",
              "FAILED_VERIFICATION" : "Kod niepoprawny"
            }
          },
          "DAILY_PLAN" : {
            "WELCOME_HOURS" : "Godzina przyjęcia",
            "FULL_NAME" : "Imię i nazwisko",
            "CONTACT_PHONE" : "Telefon kontaktowy",
            "INSURER" : "Podmiot zlecający",
            "PAYER" : "Płatnik",
            "EWUS" : "Status EWUŚ",
            "OTHER" : "Inne"
          }
        }
      }
    }
  }
});
